
const FindName = (arrayLists, value) => arrayLists.find(item => parseInt(item.id) === parseInt(value))

export default FindName